import { BASE_URL } from '../../../config/clientConfig';

/**
 * Public endpoint — no auth token required.
 * GET /api/v1/plans/public
 */
export const getPublicPlans = async () => {
  const res = await fetch(`${BASE_URL}/api/v1/plans/public`);
  if (!res.ok) throw new Error(`Failed to load plans (${res.status})`);
  return res.json(); // { success, data: { plans: [...] } }
};

/**
 * Public endpoint — no auth token required.
 * GET /api/v1/policies/current
 */
export const getCurrentPolicies = async () => {
  const res = await fetch(`${BASE_URL}/api/v1/policies/current`);
  if (!res.ok) throw new Error(`Failed to load current policies (${res.status})`);
  return res.json();
};

/**
 * Public endpoint — no auth token required.
 * GET /api/v1/policies/current/:policyKey
 */
export const getCurrentPolicyByKey = async (policyKey) => {
  const res = await fetch(`${BASE_URL}/api/v1/policies/current/${encodeURIComponent(policyKey)}`);
  if (!res.ok) throw new Error(`Failed to load policy (${res.status})`);
  const contentType = res.headers.get("content-type") || "";
  if (contentType.includes("application/json")) {
    return res.json();
  }
  // API returned HTML — wrap it so the page can render it directly
  const html = await res.text();
  return { data: { policy: { title: "", content: html, _rawHtml: true } } };
};
